export const initialFilters = {
    clients: '',
    projects: '',
    products: '',
};

export const PRODUCT_OPTIONS = [
    { label: 'Drilling Optimization', value: 'drilloptim' },
    { label: 'Drill BI', value: 'drillbi' },
];

export const STREAMING_STATUS_OPTIONS = [
    { label: 'Created', value: 'C', color: 'blue' },
    { label: 'Waiting', value: 'W', color: 'yellow' },
    { label: 'Active', value: 'A', color: 'green' },
    { label: 'Inactive', value: 'I', color: 'gray' },
    { label: 'Error', value: 'E', color: 'red' },
    { label: 'Nonexistent', value: 'N', color: 'orange' },
];

export const TYPES_OF_STREAM = {
    OS: 'os',
    TBD: 'tbd',
    DEFAULT: 'default'
}

export const NAMES_OF_STREAM = {
    DRILL_BI: "Drill BI",
    DRILL_OP: "Drilling Optimization"
}
